<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-fade">
  <p id="overlay-spinner-text">{{ text }}</p>
</ngx-spinner>